import { SxProps, Theme } from "@mui/material";

export const accentGradientText = (gradient: string) => ({
  background: gradient,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
});

export const premiumCard: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "inset 0 1px 0 0 rgba(255,255,255,0.06)",
};

export const darkSectionOuter: SxProps<Theme> = {
  background: "#0a0f1e",
  py: { xs: 8, md: 12 },
};

export const scrimGradient = (direction: "right" | "left"): string =>
  `linear-gradient(to ${direction}, rgba(4,8,20,0.97) 0%, rgba(4,8,20,0.9) 28%, rgba(4,8,20,0.55) 52%, rgba(4,8,20,0.12) 74%, rgba(4,8,20,0) 100%)`;

export const mobileScrim =
  "linear-gradient(to top, rgba(4,8,20,0.97) 0%, rgba(4,8,20,0.85) 55%, rgba(4,8,20,0.55) 100%)";

export const mobileBandHeight = "clamp(320px, 42vh, 460px)";

export const heroOuter: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  overflow: "hidden",
  background: "#0a0f1e",
  minHeight: { xs: "90vh", md: "100vh" },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  py: { xs: 12, md: 16 },
};

export const heroVideo: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  zIndex: 0,
  pointerEvents: "none",
};

export const heroVideoOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  zIndex: 1,
  pointerEvents: "none",
  background: "linear-gradient(180deg, rgba(5,12,35,0.60) 0%, rgba(10,15,30,0.72) 55%, #0a0f1e 100%)",
};

export const heroTopGlow: SxProps<Theme> = {
  position: "absolute",
  top: "-30%",
  left: "50%",
  transform: "translateX(-50%)",
  width: 900,
  height: 900,
  borderRadius: "50%",
  zIndex: 1,
  pointerEvents: "none",
  filter: "blur(90px)",
};

export const heroBottomRightFade: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  right: 0,
  width: { xs: 300, md: 520 },
  height: { xs: 230, md: 380 },
  zIndex: 1,
  pointerEvents: "none",
  background:
    "radial-gradient(ellipse at bottom right, #0a0f1e 0%, #0a0f1e 42%, rgba(10,15,30,0.92) 60%, rgba(10,15,30,0) 85%)",
};

export const heroContainer: SxProps<Theme> = {
  position: "relative",
  zIndex: 2,
  textAlign: { xs: "center", md: "left" },
  display: { md: "flex" },
  alignItems: { md: "flex-end" },
  justifyContent: { md: "space-between" },
  gap: { md: 7 },
};

export const heroCopyBox: SxProps<Theme> = {
  maxWidth: { md: 600 },
};

export const heroEyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  mb: 3,
};

export const heroTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.6rem", md: "4rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  color: "white",
  mb: 3,
};

export const heroSubtitle: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  lineHeight: 1.7,
  maxWidth: { xs: 620, md: 600 },
  mx: { xs: "auto", md: 0 },
  mb: 5,
};

export const heroCtaRow: SxProps<Theme> = {
  display: "flex",
  justifyContent: { xs: "center", md: "flex-start" },
};

export const heroIncentiveAside: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  flex: { md: "0 0 340px" },
  width: { md: 340 },
  maxWidth: { xs: 380, md: 340 },
  mx: { xs: "auto", md: 0 },
  mt: { xs: 5.5, md: 0 },
  alignSelf: { md: "flex-end" },
  textAlign: { xs: "center", md: "left" },
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(251,146,60,0.28)",
  borderRadius: "20px",
  py: 3,
  px: 3.5,
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  boxShadow: "0 20px 50px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.08)",
  "&::before": {
    // eslint-disable-next-line quotes
    content: '""',
    position: "absolute",
    inset: 0,
    zIndex: 0,
    pointerEvents: "none",
    background: "radial-gradient(circle at 50% 0%, rgba(251,146,60,0.18) 0%, transparent 70%)",
  },
};

export const heroIncentiveEyebrowRow: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  mb: 1.75,
};

export const heroIncentivePulseDot: SxProps<Theme> = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  animation: "hicPulse 1.8s ease-in-out infinite",
  "@keyframes hicPulse": {
    "0%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.4, transform: "scale(1.4)" },
    "100%": { opacity: 1, transform: "scale(1)" },
  },
};

export const heroIncentiveEyebrowText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.72rem",
  fontWeight: 700,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
};

export const heroIncentiveValueRow: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  lineHeight: 1,
  display: "flex",
  alignItems: "baseline",
  justifyContent: { xs: "center", md: "flex-start" },
  gap: 1,
};

export const heroIncentivePrefixSuffix: SxProps<Theme> = {
  fontSize: { xs: "1rem", md: "1.15rem" },
  color: "white",
};

export const heroIncentiveValueSize: SxProps<Theme> = {
  fontSize: { xs: "3.2rem", md: "3.6rem" },
};

export const heroIncentiveNote: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "0.85rem",
  lineHeight: 1.5,
  mt: 1.5,
};

export const sectionHeadingWrap: SxProps<Theme> = {
  textAlign: "center",
  mx: "auto",
  mb: { xs: 6, md: 8 },
};

export const sectionHeadingEyebrow: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
  transition: "opacity 0.6s ease, transform 0.6s ease",
};

export const sectionHeadingTitle: SxProps<Theme> = {
  color: "white",
  fontSize: { xs: "2.2rem", md: "3rem" },
  fontWeight: 800,
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  fontFamily: "'Poppins', sans-serif",
  transition: "opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s",
};

export const sectionHeadingSub: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.05rem" },
  lineHeight: 1.7,
  transition: "opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s",
};

export const cardGlow: SxProps<Theme> = {
  position: "absolute",
  top: -80,
  right: -80,
  width: 220,
  height: 220,
  zIndex: 0,
  borderRadius: "50%",
  filter: "blur(44px)",
  pointerEvents: "none",
};

export const crisisCardKicker: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.5)",
  fontFamily: "'Barlow', sans-serif",
  mb: 1.5,
};

export const crisisCardWord: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "1.9rem", md: "2.2rem" },
  letterSpacing: "-0.02em",
  mb: 2,
};

export const crisisCardBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  lineHeight: 1.7,
};

export const cardsGrid3: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
  gap: { xs: 3, md: 4 },
};

export const cardsGrid2: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
  gap: { xs: 3, md: 4 },
};

export const energyCopyIndexWatermark: SxProps<Theme> = {
  position: "absolute",
  top: { xs: -28, md: -48 },
  left: { xs: -6, md: -16 },
  zIndex: 0,
  pointerEvents: "none",
  userSelect: "none",
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: "clamp(8rem, 14vw, 14rem)",
  lineHeight: 1,
  opacity: 0.15,
};

export const energyCopyEyebrowRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  mb: 2,
};

export const energyCopyEyebrowText: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  fontFamily: "'Barlow', sans-serif",
};

export const energyCopyHeadline: SxProps<Theme> = {
  color: "white",
  fontSize: { xs: "2.2rem", md: "2.8rem", lg: "3.4rem" },
  fontWeight: 800,
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  fontFamily: "'Poppins', sans-serif",
  mb: 2.5,
};

export const energyCopyTagline: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontWeight: 600,
  fontSize: "1rem",
  mb: 2,
};

export const energyCopyDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.05rem" },
  lineHeight: 1.7,
  maxWidth: 520,
  mb: 4,
};

export const energyCopyFeaturesWrap: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  mb: 4,
};

export const energyCopyFeatureRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
};

export const energyCopyFeatureIconBase: SxProps<Theme> = {
  fontSize: "1.15rem",
  mt: "2px",
  flexShrink: 0,
};

export const energyCopyFeatureText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  lineHeight: 1.6,
};

export const energyCopyStatsRow: SxProps<Theme> = {
  display: "flex",
  gap: 5,
  flexWrap: "wrap",
  pt: 3,
  mb: 4,
  borderTop: "1px solid rgba(255,255,255,0.08)",
};

export const energyCopyStatValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: "2.2rem",
  lineHeight: 1,
  mb: 0.5,
};

export const energyCopyStatUnit: SxProps<Theme> = {
  fontSize: "1.1rem",
  fontWeight: 700,
  ml: 0.5,
};

export const energyCopyStatLabel: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.6)",
  fontFamily: "'Barlow', sans-serif",
};

export const energyCopySeeSavingsLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  mb: 1.5,
};

export const energyCopyFormWrap: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "stretch",
  width: "100%",
  maxWidth: 400,
  borderRadius: "50px",
  background: "rgba(255,255,255,0.07)",
  overflow: "hidden",
};

export const energyCopyInput: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  height: 50,
  px: "20px",
  fontSize: "0.95rem",
  fontFamily: "'Barlow', sans-serif",
  color: "white",
  background: "transparent",
  border: "none",
  outline: "none",
  "&::placeholder": { color: "rgba(255,255,255,0.4)" },
};

export const energyCopyButtonBase: SxProps<Theme> = {
  flexShrink: 0,
  height: 50,
  px: "26px",
  fontSize: "0.9rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  color: "#0a0f1e",
  border: "none",
  borderRadius: "0 50px 50px 0",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "filter 0.2s ease",
  "&:hover": { filter: "brightness(1.08)" },
};

export const energyBgWrap: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  zIndex: 0,
  overflow: "hidden",
};

export const energyBgImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  willChange: "transform",
  transition: "transform 1.2s cubic-bezier(0.22,1,0.36,1)",
};

export const mobileBandWrap: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  height: mobileBandHeight,
  overflow: "hidden",
  flexShrink: 0,
};

export const mobileBandFadeBase: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "100px",
  pointerEvents: "none",
};

export const energySectionOuter: SxProps<Theme> = {
  position: "relative",
  width: "100%",
};

export const energySectionDesktopWrap: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  overflow: "hidden",
  minHeight: { xs: "90vh", md: "100vh" },
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  py: { xs: 10, md: 0 },
};

export const energySectionEdgeBase: SxProps<Theme> = {
  position: "absolute",
  left: 0,
  width: "100%",
  height: "120px",
  zIndex: 1,
  pointerEvents: "none",
};

export const energySectionMobileWrap: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  width: "100%",
};

export const energySectionMobileCopyWrap: SxProps<Theme> = {
  width: "100%",
  px: 3,
  py: 6,
};

export const arbitrageInfoCardsGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
  gap: "14px",
  mb: "14px",
};

export const arbitrageInfoCard: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: "18px",
  borderRadius: "16px",
  padding: "26px 30px",
};

export const arbitrageInfoIconWrap: SxProps<Theme> = {
  width: 46,
  height: 46,
  borderRadius: "12px",
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
};

export const arbitrageInfoTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: "17px",
  fontWeight: 600,
};

export const arbitrageInfoDesc: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "13px",
  mt: "3px",
};

export const arbitrageDialCaptionLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "10px",
  mb: "6px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  fontWeight: 600,
};

export const arbitrageDialCaptionValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: "46px",
  fontWeight: 600,
  letterSpacing: "-0.03em",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1,
};

export const arbitrageDialUnitLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "12px",
  mt: "6px",
};

export const arbitrageDragHintRow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "11.5px",
};

export const arbitrageDragHintDot: SxProps<Theme> = {
  width: 7,
  height: 7,
  borderRadius: "50%",
  flexShrink: 0,
};

export const arbitrageCalculatorOuter: SxProps<Theme> = {
  borderRadius: "20px",
  padding: { xs: "24px", md: "32px" },
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "auto 1fr" },
  gap: { xs: "32px", md: "48px" },
  alignItems: "center",
  transition: "opacity 0.6s ease, transform 0.6s ease",
};

export const arbitrageDialColumn: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "14px",
};

export const arbitrageTilesGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateRows: "auto 1fr",
  gap: "20px",
};

export const arbitrageSmallTilesGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
  gap: "12px",
};

export const arbitrageSmallTile: SxProps<Theme> = {
  padding: "14px 18px",
  borderRadius: "12px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
};

export const arbitrageSmallTileLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "12.5px",
};

export const arbitrageSmallTileValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: "15px",
  fontVariantNumeric: "tabular-nums",
};

export const arbitrageBigTilesGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
  gap: "12px",
};

export const arbitrageBigTile: SxProps<Theme> = {
  padding: "22px 24px",
  borderRadius: "16px",
};

export const arbitrageBigTileValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: "34px",
  fontWeight: 600,
  letterSpacing: "-0.025em",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1,
};

export const arbitrageBigTileLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "12px",
  mt: "8px",
};

export const arbitrageCalculatorDisclaimer: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  mt: "12px",
  fontSize: "11.5px",
  lineHeight: 1.5,
};

export const arbitrageFlowOuter: SxProps<Theme> = {
  borderRadius: "20px",
  padding: { xs: "24px", md: "32px" },
  mt: "14px",
  transition: "opacity 0.6s ease, transform 0.6s ease",
};

export const arbitrageFlowHeaderRow: SxProps<Theme> = {
  display: "flex",
  alignItems: { xs: "flex-start", md: "flex-end" },
  justifyContent: "space-between",
  flexDirection: { xs: "column", md: "row" },
  flexWrap: "wrap",
  gap: "12px",
  mb: "18px",
};

export const arbitrageFlowEyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "10px",
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  mb: "6px",
};

export const arbitrageFlowHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: "19px",
  letterSpacing: "-0.01em",
};

export const arbitrageFlowLegendRow: SxProps<Theme> = {
  display: "flex",
  gap: "22px",
  flexWrap: "wrap",
};

export const arbitrageFlowLegendItem: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const arbitrageFlowLegendSwatch: SxProps<Theme> = {
  width: 12,
  height: 12,
  borderRadius: "3px",
};

export const arbitrageFlowLegendLineSwatch: SxProps<Theme> = {
  width: 14,
  height: 3,
  borderRadius: "2px",
};

export const arbitrageFlowLegendLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "12px",
};

export const arbitrageFlowSvgWrap: SxProps<Theme> = {
  width: "100%",
  overflow: "hidden",
};

export const backupModeHeaderRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.5,
  mb: 3,
};

export const backupModeTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: "1.4rem",
  color: "white",
  letterSpacing: "-0.02em",
};

export const backupModePill: SxProps<Theme> = {
  px: 1.75,
  py: 0.5,
  borderRadius: "50px",
  fontFamily: "'Barlow', sans-serif",
  fontWeight: 700,
  fontSize: "0.75rem",
  letterSpacing: "0.05em",
  whiteSpace: "nowrap",
};

export const backupModeItemsGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 2,
};

export const backupModeItemRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const backupModeItemText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "0.95rem",
};

export const incentiveCardWrap: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  maxWidth: 1000,
  mx: "auto",
  borderRadius: "24px",
  border: "1px solid rgba(251,146,60,0.35)",
  background: "rgba(255,255,255,0.02)",
  px: { xs: 3, md: 8 },
  py: { xs: 6, md: 9 },
};

export const incentiveGlowCircle: SxProps<Theme> = {
  position: "absolute",
  top: "-25%",
  left: "50%",
  transform: "translateX(-50%)",
  width: 760,
  height: 760,
  borderRadius: "50%",
  zIndex: 0,
  pointerEvents: "none",
  filter: "blur(90px)",
};

export const incentiveBgWatermarkWrap: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  zIndex: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  pointerEvents: "none",
  userSelect: "none",
};

export const incentiveBgWatermarkText: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: "clamp(12rem, 30vw, 26rem)",
  lineHeight: 1,
  opacity: 0.06,
};

export const incentiveContent: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  textAlign: "center",
};

export const incentivePillRow: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  mb: 3,
};

export const incentivePulseDot: SxProps<Theme> = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  animation: "incentivePulse 1.8s ease-in-out infinite",
  "@keyframes incentivePulse": {
    "0%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.4, transform: "scale(1.4)" },
    "100%": { opacity: 1, transform: "scale(1)" },
  },
};

export const incentivePillText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
};

export const incentiveValueBlock: SxProps<Theme> = {
  mb: 3,
};

export const incentiveValueRow: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  lineHeight: 1,
};

export const incentiveValuePrefix: SxProps<Theme> = {
  fontSize: { xs: "1.3rem", md: "1.6rem" },
  color: "white",
  mr: 1.5,
};

export const incentiveValueSuffix: SxProps<Theme> = {
  fontSize: { xs: "1.3rem", md: "1.6rem" },
  color: "white",
  ml: 1.5,
};

export const incentiveValueNumber: SxProps<Theme> = {
  fontSize: "clamp(3.5rem, 10vw, 6rem)",
};

export const incentiveValueCaption: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  mt: 1,
};

export const incentiveHeadline: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  color: "white",
  maxWidth: 760,
  mx: "auto",
  mb: 2.5,
};

export const incentiveBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.05rem" },
  lineHeight: 1.7,
  maxWidth: 620,
  mx: "auto",
  mb: 4,
};

export const incentiveFormRow: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  mt: 5,
  mb: 2.5,
};

export const incentiveDisclaimer: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.55)",
  fontSize: "0.75rem",
  whiteSpace: { xs: "normal", md: "nowrap" },
  maxWidth: { xs: 480, md: "none" },
  mx: "auto",
};

export const outcomeCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: "1.5rem",
  color: "white",
  letterSpacing: "-0.02em",
  mb: 3,
};

export const outcomeRowsWrap: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2.5,
  mb: 3,
};

export const outcomeRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  pb: 2.5,
  borderBottom: "1px solid rgba(255,255,255,0.06)",
};

export const outcomeRowLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "0.95rem",
};

export const outcomeRowValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "1.3rem",
};

export const outcomeNoteBox: SxProps<Theme> = {
  borderRadius: "12px",
  p: 2,
};

export const outcomeNoteLabel: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  fontFamily: "'Barlow', sans-serif",
  mb: 0.5,
};

export const outcomeNoteText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "0.9rem",
};

export const ctaFinalOuter: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  py: { xs: 8, md: 12 },
};

export const ctaFinalBgImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  zIndex: 0,
};

export const ctaFinalOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  zIndex: 1,
  pointerEvents: "none",
  background:
    "linear-gradient(180deg, #0a0f1e 0%, rgba(10,15,30,0.86) 20%, rgba(10,15,30,0.82) 60%, rgba(10,15,30,0.9) 100%)",
};

export const ctaFinalOutcomesGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
  gap: { xs: 3, md: 4 },
  mb: { xs: 6, md: 8 },
};

export const ctaFinalBodyWrap: SxProps<Theme> = {
  textAlign: "center",
  maxWidth: 640,
  mx: "auto",
};

export const ctaFinalBodyText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.1rem" },
  lineHeight: 1.7,
  mb: 4,
};

export const ctaFinalFormRow: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
};
